import React from 'react';
import { Form, Col } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter } from 'dva/router';
import PropTypes from 'prop-types';
import helpers from '../../../utils/helpers';
import { SelectInput } from '../../../components';
import { clientStatusToTextLabel } from '../constants';
import { ACTION_CLIENT_PACKAGES_LOAD_FULL_LIST } from '../../../models/clientPackages';

const FormItem = Form.Item;

class ClientsFilter extends React.Component {
  static propsTypes = {
    formFields: PropTypes.object.isRequired, // filter form fields
  }

  componentDidMount() {
    this.props.dispatch({ type: ACTION_CLIENT_PACKAGES_LOAD_FULL_LIST });
  }

  filterChange = () => {
    setTimeout(() => {
      const currentFilters = this.props.form.getFieldsValue();
      this.props.onChange(currentFilters);
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form>
        <Col span={5}>
          <FormattedMessage id="Component.Administration.Clients.FilterByStatus">
            {msg => (
              <FormItem colon={false}>
                {getFieldDecorator('statuses', {
                  initialValue: this.props.formFields.statuses,
                })(
                  <SelectInput
                    showArrow
                    onBlur={this.filterChange}
                    onDeselect={this.filterChange}
                    mode="multiple"
                    placeholder={msg}
                    options={Object.entries(clientStatusToTextLabel).map(([key, label]) => {
                      return {
                        id: key,
                        name: this.props.intl.formatMessage({
                          id: label,
                        }),
                      };
                    })}
                    filterOption={helpers.multipleSelectFilter}
                  />,
                )}
              </FormItem>
            )}
          </FormattedMessage>
        </Col>
        <Col span={5}>
          <FormattedMessage id="Component.Administration.Clients.FilterByPackage">
            {msg => (
              <FormItem colon={false}>
                {getFieldDecorator('clientPackageIds', {
                  initialValue: this.props.formFields.clientPackageIds,
                })(
                  <SelectInput
                    showArrow
                    onBlur={this.filterChange}
                    onDeselect={this.filterChange}
                    mode="multiple"
                    placeholder={msg}
                    options={this.props.clientPackages.clientPackagesFullList.map((item) => {
                      return {
                        id: item.id,
                        name: item.title,
                      };
                    })}
                    filterOption={helpers.multipleSelectFilter}
                  />,
                )}
              </FormItem>
            )}
          </FormattedMessage>
        </Col>
      </Form>
    );
  }
}

export default withRouter(connect(({ clientPackages }) => ({
  clientPackages,
}))(Form.create()(injectIntl(ClientsFilter))));



// WEBPACK FOOTER //
// ./src/components/Clients/ClientsFilter/ClientsFilter.js